module.exports = __webpack_public_path__ + "static/media/live-casino.dd5b6143.svg";